import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function GiftRegistry() {
  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-5 text-foreground-500">Mesa de regalos</p>
          <div className="mx-auto h-px w-16 bg-primary-300" />
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <p className="mx-auto mt-10 max-w-md font-heading text-xl italic leading-relaxed text-foreground-700 sm:text-2xl md:text-3xl">
            {weddingConfig.giftRegistryText}
          </p>
        </ScrollReveal>

        {weddingConfig.giftRegistryInfo && (
          <ScrollReveal delay={2}>
            <p className="mx-auto mt-8 max-w-md font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
              {weddingConfig.giftRegistryInfo}
            </p>
          </ScrollReveal>
        )}

        <ScrollReveal delay={2}>
          <div className="mt-10 md:mt-12">
            <a
              href={weddingConfig.giftRegistryUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline hover:bg-background-100"
            >
              <i className="ri-gift-line text-sm" />
              Ver mesa de regalos
            </a>
          </div>
        </ScrollReveal>

        {/* Optional bank transfer info — hidden by default */}
        {weddingConfig.showBankTransfer && weddingConfig.bankTransferInfo && (
          <ScrollReveal delay={3}>
            <div className="mx-auto mt-10 max-w-md border border-background-300/50 px-6 py-6 sm:px-8">
              <p className="micro-label mb-3 text-primary-600">Lluvia de sobres</p>
              <p className="font-body text-sm leading-relaxed text-foreground-600 sm:text-base">
                {weddingConfig.bankTransferInfo}
              </p>
            </div>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}